module.exports = __webpack_public_path__ + "assets/img/store-reg-banner-01.580d06fd.png";